module.exports = __webpack_public_path__ + "static/media/support.e98f11bf.svg";